export default "__VITE_ASSET__B2a3zfW1__"